/**
 * Classifier for the PDF.js worker-teardown errors that the `<Activity>` tab
 * shell provokes on a react-pdf subtree. Kept in its own module so the boundary
 * component file exports only a component (react-refresh), and so the predicate
 * is unit-testable in isolation.
 *
 * pdf.js surfaces a destroyed/terminated worker in a few shapes: the nulled
 * `messageHandler.sendWithPromise` read (the Activity reveal race), and the
 * worker's own termination guards. Message-substring match — the stack is
 * minified in production, so the message is the only stable signal.
 */
const TEARDOWN_MESSAGE_FRAGMENTS = [
  'sendWithPromise',
  'Worker was terminated',
  'Worker was destroyed',
  'ensureNotTerminated',
] as const;

function messageOf(error: unknown): string {
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const { message } = error as { message: unknown };
    return typeof message === 'string' ? message : '';
  }
  return typeof error === 'string' ? error : '';
}

export function isPdfWorkerTeardownError(error: unknown): boolean {
  const message = messageOf(error);
  return TEARDOWN_MESSAGE_FRAGMENTS.some((fragment) => message.includes(fragment));
}
